import { Button } from 'antd';
import { useTranslation } from 'next-i18next';

const ThreadsPostNoMedia = () => {
  const { t } = useTranslation();

  const handleTryAgain = () => {
    window.scrollTo({
      top: 0,
    });
  };

  return (
    <div className="flex flex-col items-center justify-center h-[164px] py-7 text-base bg-[#F5F5F5] rounded-xl">
      <div className="font-bold">{t('No Media Content Detected')}</div>
      <div>{t('No images, GIFs, or videos found. Please check another Threads post link.')}</div>
      <Button
        className="w-[226px] h-11 mt-5 bg-gradient-to-b from-[#725cff] to-[rgba(141,131,255,0.8)] text-white rounded-full text-base leading-5 font-medium shadow-[0px_4px_12px_0px_rgba(114,92,255,0.2)]"
        onClick={handleTryAgain}
      >
        {t('TRYAGAIN')}
      </Button>
    </div>
  );
};

export default ThreadsPostNoMedia;
